import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import React from 'react';
import MiniTable from '../../components/mini-table';
import TableCellEllipsis from '../../components/table-cell-ellipsis';
import { compareStrings } from '../../util/string';
import { formatCnpj } from '../../util/cnpj';

export default function SociosTable({ dataSource, loading, miniTableRef, title }) {
  const { t } = useTranslation();

  const renderCell = text => <TableCellEllipsis text={text || ' '} />;

  const renderBoolean = (value) => <div style={{ minWidth: 50 }}>{value ? 'Sim' : 'Não'}</div>;

  const columns = [
    {
      title: t('CPF/CNPJ'),
      dataIndex: 'documento',
      key: 'documento',
      width: 150,
      sorter: (a, b) => compareStrings(a.documento, b.documento),
      render: text => formatCnpj(text || ''),
    },
    {
      title: t('Nome'),
      dataIndex: 'nome',
      key: 'nome',
      width: 250,
      sorter: (a, b) => compareStrings(a.nome, b.nome),
      render: renderCell,
    },
    {
      title: t('Email'),
      dataIndex: 'email',
      key: 'email',
      width: 200,
      sorter: (a, b) => compareStrings(a.email, b.email),
      render: renderCell,
    },
    {
      title: t('Exterior'),
      dataIndex: 'exterior',
      key: 'exterior',
      width: 100,
      sorter: (a, b) => compareStrings(a.exterior, b.exterior),
      render: (value) => renderBoolean(value ?? false),
    },
    {
      title: t('Incapacitado'),
      dataIndex: 'incapacitado',
      key: 'incapacitado',
      width: 120,
      sorter: (a, b) => compareStrings(a.incapacitado, b.incapacitado),
      render: (value) => renderBoolean(value ?? false),
    },
    {
      title: t('Observação'),
      dataIndex: 'obs',
      key: 'obs',
      width: 250,
      sorter: (a, b) => compareStrings(a.obs, b.obs),
      render: renderCell,
    },
  ];

  const preparedData = (dataSource || []).map(socio => ({
    ...socio,
    exterior: socio.exterior ?? false,
    incapacitado: socio.incapacitado ?? false,
    obs: socio.obs ?? '',
    email: socio.email ?? '',
  }));

  return (
    <MiniTable
      ref={miniTableRef}
      columns={columns}
      dataSource={preparedData}
      loading={loading}
      title={title}
      scroll={{ y: 350 }}
    />
  );
}

SociosTable.propTypes = {
  dataSource: PropTypes.array,
  loading: PropTypes.bool,
  miniTableRef: PropTypes.object,
  title: PropTypes.func,
};
